import React, { useCallback, useEffect, useState } from "react";
import HeaderFilterCoursesDesktop from "./HeaderFilterCoursesDesktop";
import HeaderFilterCoursesMobile from "./HeaderFilterCoursesMobile";
import { setLevels as setLevelsFunc } from "store/game/thunkActions";
import { useNavigate } from "react-router-dom";
import { useTypedDispatch, useTypedSelector } from "store";
import { setGame, setGameMultiple } from "store/game/slice";
import { showMobile } from "helpers/adaptation";
import { localStorageKeys } from "config/localStorageKeys";
import { updateSettings } from "../../../store/users/slice";

export interface HeaderFilterCoursesProps {
  title?: string;
  type?: "deffense" | "tricks" | "bidding" | "handPlay" | "def_lead";
  onChangeText?: (val: string) => void;
  value?: string;
  onHandleChangeLevel?: (val: any) => void;
  levels?: any;
  onChangeLevel?: any;
  onLastExercise?: any;
  dataLastExercise?: any;
  onExpireModal?: any;
}

const HeaderFilterCourses = (props: HeaderFilterCoursesProps) => {
  const [dataLastExercise, setDataLastExercise] = useState<any>(null);
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();
  const { client } = useTypedSelector((store) => store.user);

  const [levels, setLevels] = useState({
    hard: false,
    medium: false,
    ease: false
  });

  useEffect(() => {
    const resLevels = localStorage.getItem("levels");
    if (resLevels) {
      setLevels(JSON.parse(resLevels));
    }
  }, []);

  useEffect(() => {
    let key = "";
    switch (props.type) {
      case "bidding":
        key = "bidding";
        break;
      case "handPlay":
        key = "hand_play_exercise";
        break;
      case "tricks":
        key = "tricks_exercise";
        break;
      case "deffense":
        key = "deffense_exercise";
        break;
      case "def_lead":
        key = "def_lead_exercise";
        break;
    }
    const getData = localStorage.getItem(key);
    if (getData) {
      setDataLastExercise(JSON.parse(getData));
    }
  }, [props.type]);

  const onLastExercise = useCallback(() => {
    if (!dataLastExercise || !props.type) return;

    dispatch(updateSettings({ shuffle: false }));
    dispatch(
      setGameMultiple({
        type_game: props.type,
        data: dataLastExercise
      })
    );
    dispatch(
      setGameMultiple({
        type_game: "handPlay",
        data: {}
      })
    );
    dispatch(
      setGameMultiple({
        type_game: "deffense",
        data: {}
      })
    );
    localStorage.setItem(localStorageKeys.shuffleAction, "false");
    switch (props.type) {
      case "bidding":
        dispatch(setGame({}));
        navigate(dataLastExercise.type === "bidding" ? "/bidding" : "/bidding_interactive");
        break;
      case "handPlay":
        navigate("/hand_play");
        break;
      case "tricks":
        navigate("/tricks_play");
        break;
      case "def_lead":
        navigate("/def_lead_play");
        break;
      case "deffense":
        navigate("/deffense_play");
        break;
    }
  }, [dataLastExercise, dispatch, navigate, props]);

  const onChangeLevel = useCallback(
    (type: "hard" | "ease" | "medium") => {
      const res = { ...levels, [type]: !levels[type] };
      setLevels(res);

      const arrayLevel = [];

      if (res?.ease) {
        arrayLevel.push("10");
      }
      if (res?.medium) {
        arrayLevel.push("20");
      }
      if (res?.hard) {
        arrayLevel.push("30");
      }
      dispatch(setLevelsFunc(arrayLevel));
      localStorage.setItem("levels", JSON.stringify(res));
      props.onHandleChangeLevel && props.onHandleChangeLevel(res);
    },
    [dispatch, levels, props]
  );

  const handleLastExercise = useCallback(() => {
    if (!client?.dateExpirde) {
      return props.onExpireModal && props.onExpireModal();
    }
    onLastExercise && onLastExercise();
  }, [client?.dateExpirde, onLastExercise, props]);

  return (
    <>
      {!showMobile && (
        <HeaderFilterCoursesDesktop
          {...props}
          onLastExercise={handleLastExercise}
          onChangeLevel={onChangeLevel}
          levels={levels}
          dataLastExercise={dataLastExercise}
        />
      )}
      {showMobile && (
        <HeaderFilterCoursesMobile
          {...props}
          onLastExercise={handleLastExercise}
          onChangeLevel={onChangeLevel}
          levels={levels}
          dataLastExercise={dataLastExercise}
        />
      )}
    </>
  );
};

export default HeaderFilterCourses;
